import React, { useState } from 'react';
import { List, Typography, Spin, Button, Modal, Badge, Empty, Table } from 'antd';
import { useQuery, useMutation, useQueryClient } from 'react-query';
import apiClient from '../../services/api';
import { MailOutlined, CheckOutlined, BellOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const Inbox = () => {
    const queryClient = useQueryClient();
    const [selectedNotification, setSelectedNotification] = useState(null);
    const [isModalVisible, setIsModalVisible] = useState(false);

    // Fetch Notifications
    const { data: notificationsData, isLoading } = useQuery('notifications', async () => {
        const response = await apiClient.get('/notifications');
        return response.data; // assuming paginated or list
    });

    const markAsReadMutation = useMutation((id) => apiClient.post(`/notifications/${id}/read`), {
        onSuccess: () => {
            queryClient.invalidateQueries('notifications');
            queryClient.invalidateQueries('unread_notifications');
        }
    });

    const markAllAsReadMutation = useMutation(() => apiClient.post('/notifications/read-all'), {
        onSuccess: () => {
            queryClient.invalidateQueries('notifications');
            queryClient.invalidateQueries('unread_notifications');
        }
    });

    const handleViewDetail = (item) => {
        setSelectedNotification(item);
        setIsModalVisible(true);
        if (!item.read_at) {
            markAsReadMutation.mutate(item.id);
        }
    };

    const handleCloseModal = () => {
        setIsModalVisible(false);
        setSelectedNotification(null);
    };

    const handleMarkAllRead = () => {
        markAllAsReadMutation.mutate();
    };

    const renderCertsTable = (certs) => {
        if (!certs || certs.length === 0) return <Empty description="No hay certificados" />;

        const columns = [
            { title: 'Placa', dataIndex: 'plate', key: 'plate' },
            { title: 'Tipo de Cert.', dataIndex: 'certification_type', key: 'certification_type' },
            { title: 'Cliente (Billing)', dataIndex: 'customer_name', key: 'customer_name' },
            { title: 'Celular', dataIndex: 'phone', key: 'phone' },
            { title: 'Vencimiento', dataIndex: 'expires_at', key: 'expires_at' }
        ];

        return <Table dataSource={certs} columns={columns} rowKey="id" pagination={false} size="small" />;
    };

    return (
        <div style={{ backgroundColor: '#fff', padding: 24, minHeight: '80vh', borderRadius: 8 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
                <Title level={3}><BellOutlined /> Notificaciones (Inbox)</Title>
                <Button onClick={handleMarkAllRead} icon={<CheckOutlined />}>
                    Marcar todo como leído
                </Button>
            </div>

            {isLoading ? (
                <div style={{ textAlign: 'center', padding: 50 }}><Spin size="large" /></div>
            ) : (
                <List
                    itemLayout="horizontal"
                    dataSource={notificationsData?.data || notificationsData || []}
                    locale={{ emptyText: <Empty description="No tienes notificaciones" /> }}
                    renderItem={item => (
                        <List.Item
                            actions={[
                                <Button type="link" onClick={() => handleViewDetail(item)}>Ver Detalle</Button>
                            ]}
                            style={{ backgroundColor: item.read_at ? '#ffffff' : '#f0f5ff', padding: 16, borderRadius: 8, marginBottom: 8, border: item.read_at ? '1px solid #f0f0f0' : '1px solid #adc6ff' }}
                        >
                            <List.Item.Meta
                                avatar={<Badge dot={!item.read_at}><MailOutlined style={{ fontSize: 24, color: '#1890ff' }} /></Badge>}
                                title={<a onClick={() => handleViewDetail(item)}>{item.data.message || 'Notificación'}</a>}
                                description={<Text type="secondary">{new Date(item.created_at).toLocaleString()}</Text>}
                            />
                        </List.Item>
                    )}
                />
            )}

            <Modal
                title={`Detalles de: ${selectedNotification?.data?.company_name || 'Empresa'}`}
                visible={isModalVisible}
                onCancel={handleCloseModal}
                footer={[
                    <Button key="close" type="primary" onClick={handleCloseModal}>
                        Cerrar
                    </Button>
                ]}
                width={700}
            >
                {selectedNotification && (
                    <div>
                        <p>{selectedNotification.data.message}</p>
                        <Title level={5}>Lista de Certificados por Vencer</Title>
                        {renderCertsTable(selectedNotification.data.certifications)}
                    </div>
                )}
            </Modal>
        </div>
    );
};

export default Inbox;
